
import { ref } from '@vue/composition-api'
import store from '@/store'
//import { plans, reFilterPlans } from '@/app/reports/share/helper'
import { ReportService } from '@/app/reports/share/report.service'



export default function reportForm() {

  const owners = ref([])
  const contracts=ref([]);
  const plans=ref([])





  const refilterContractByOwner =(owners_ids)=>{
             
     
     
     ReportService.getAreasOptions({
      'user': store.state.auth.userData.id,
      'type':'contract',
      'contractors':owners_ids
     }).then(response=>{

      contracts.value = response.data

     })

   
  }

  const planfilterdata=ref({

    type:"plan",
    planType:'garden',
    cols:"id,name",
    user: store.state.auth.userData.id
  });
  
  ReportService.getCategoriesFilterBy({
    type: 'plan',
   
  }).then(response => { 
    owners.value = response.data.owners
    contracts.value = response.data.contracts
  
  })
 

  const reFilterPlans=(name,data)=>{

    if(name=="owners"){
    
      planfilterdata.value.owner=data.owners;
   
     }else if(name=="contracts"){
  
      planfilterdata.value.contract=data.contracts;
     
     }
  
    
    
    ReportService.getPlanOptions(
      planfilterdata.value
     
      
     ).then(response =>{   plans.value = response.data})
  
  
  
  
  }


  



  ReportService.getPlanOptions({
    type: "plan",
    planType: 'garden',
    cols: "id,name",
    user: store.state.auth.userData.id
  }).then(response => { plans.value = response.data })


 
  
  return {
    
  
    owners,
    contracts,
   
    plans,
    reFilterPlans,
    refilterContractByOwner
   
  }
}
